import i18next from 'i18next';
import { map } from 'lodash';

import { FormikSelectOption } from 'components';
import { OrderType, P2PProviderType } from 'enums';

const getTypeLabel = (type: P2PProviderType | string) =>
  i18next.t(`p2p_providers.${type}`, { defaultValue: type });

const typeOptions: FormikSelectOption[] = map(P2PProviderType, (type) => ({
  value: type,
  label: getTypeLabel(type),
}));

type P2PProviderEnabledFlags = {
  payinConfig?: { enabled?: boolean };
  payoutConfig?: { enabled?: boolean };
};

// Means "inactive only if neither direction is enabled" — explicit opt-in for callers that
// don't care which direction; omitting `direction` entirely skips the active/inactive check
// altogether, e.g. contexts unrelated to this feature.
export const P2P_PROVIDER_DIRECTION_ANY = 'any' as const;

export type P2PProviderDirection =
  | OrderType
  | typeof P2P_PROVIDER_DIRECTION_ANY;

const isInactive = (
  p2pProvider: P2PProviderEnabledFlags | undefined,
  direction: P2PProviderDirection = P2P_PROVIDER_DIRECTION_ANY,
): boolean => {
  const payinEnabled = !!p2pProvider?.payinConfig?.enabled;
  const payoutEnabled = !!p2pProvider?.payoutConfig?.enabled;

  if (direction === OrderType.Payin) {
    return !payinEnabled;
  }
  if (direction === OrderType.Payout) {
    return !payoutEnabled;
  }
  return !payinEnabled && !payoutEnabled;
};

export const p2pProviderUtils = {
  getTypeLabel,
  typeOptions,
  isInactive,
};
